(function (appComponents) {

	appComponents.controllers.siteMap = function (Components) {
		var siteMap = {};

		siteMap.name = "siteMap";


		Components.getControllerPrototype().extend(siteMap);
		
		siteMap._b2bUnit = siteMap._getService("b2bUnit");

		// siteMap._cart = siteMap._getService("cartBase");

		siteMap.bindings = function () {

			// $("[pc-container='product--details-datapack']").off().click(function() {
			// 	var type = $(this).attr("pc-value");
			// 	siteMap.handlers.onDataPackItemClick(type);
			// });
		};


		siteMap.handlers = {

			// onDataPackItemClick: function (type) {
			// 	var stockId = siteMap.context.product.stockId;
			// 	siteMap._product.downloadDataPack(stockId, type);
			// },
		};

		siteMap.b2bUnitOnLoad = function() {
			$(document ).ready(function() {
				var unitType = siteMap._b2bUnit.unitType;
				if (unitType == "SAP") {
					$('.motors-lv-rm-sitemap').hide();
					$('.parts-lv-rm-sitemap').show();
				} else if (unitType == "ORACLE") {
					$('.motors-lv-rm-sitemap').show();
					$('.parts-lv-rm-sitemap').hide();
				}
			});
		};

		siteMap.init = function () {

			siteMap._renderPageTemplate();
			
			siteMap.b2bUnitOnLoad();
			
			siteMap._events.dispatchEvent("controllerInitialized");

		};

		return siteMap;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});